export const ArchiveStatusKey = '6';

export default {
  '3': {
    label: 'New',
    filter: '3'
  },
  '4': {
    label: 'Active',
    filter: '4'
  },
  '5': {
    label: 'Passive',
    filter: '5'
  },
  [ArchiveStatusKey]: {
    label: 'Archived',
    filter: '6'
  }
};
